import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertIcoToJpeg() {
  return (
    <ImageConverterTemplate
      sourceFormat="ICO"
      targetFormat="JPEG"
      acceptTypes=".ico,image/x-icon,image/vnd.microsoft.icon"
      slug="convert-ico-to-jpeg"
      gradientColors="from-cyan-500 to-amber-500"
      accentColor="orange"
      showQualitySlider={true}
    />
  );
}
